<template>
  <b-container fluid>
    <b-row>
      <b-col class="top_bar" />
    </b-row>
    <b-row
      ><b-col><div class="page_title">Score Tables</div></b-col></b-row
    >
    <b-row>
      <b-col>
        <h3 class="tsny_header">{{ exam.examName }}</h3>
      </b-col>
      <b-col class="col-2 float-right">
        <b-button class="tsny_button" @click="setScoreTable"
          >Save Score Tables</b-button
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h5 class="tsny_header">Section Scoring</h5>
        <section-score-table
          v-if="scoreTable"
          :course-id="courseId"
          :exam="exam"
          :score-table="scoreTable"
        />
      </b-col>
    </b-row>
    <subscore-table
      v-if="scoreTable"
      v-model="scoreTable.subscoreTable"
      :sections="exam.sections"
    />
    <set-score-table-modal
      :course-id="courseId"
      :exam-name="exam.examName"
      :score-table="scoreTable"
    />
  </b-container>
</template>

<script>
import SectionScoreTable from "../../components/Exams/ScoreTables/SectionScoreTable";
import SetScoreTableModal from "../../components/Exams/ScoreTables/SetScoreTableModal";
import SubscoreTable from "../../components/Exams/ScoreTables/SubscoreTable";
export default {
  name: "ScoreTables",
  components: { SubscoreTable, SetScoreTableModal, SectionScoreTable },
  props: {
    courseId: {
      type: String,
      default: null
    },
    exam: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    scoreTable: null
  }),
  mounted() {
    this.scoreTable = this.exam.scoreTable || {};
  },
  methods: {
    setScoreTable() {
      this.$bvModal.show("setScoreTableModal");
    }
  }
};
</script>

<style scoped></style>
